import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink } from "lucide-react";
import { AdminGoogleCalendar } from "@/components/AdminGoogleCalendar";
import { Badge, btn, d, dt, inputCls, Loading, PageHeader, Table, useAdminGet } from "@/components/admin/ui";

export const Administrateurs = () => {
  const [rows] = useAdminGet("/admin/hub/administrateurs");
  if (!rows) return <Loading />;
  return <div data-testid="admin-administrateurs"><PageHeader title="Administrateurs" /><Table testid="admin-admins-table" cols={["Nom", "E-mail", "Rôle", "Depuis"]} empty="Aucun administrateur." rows={rows.map((u) => [u.name || "—", u.email, <Badge tone="ok">admin</Badge>, d(u.created_at)])} /></div>;
};

export const Integrations = () => (
  <div className="space-y-6" data-testid="admin-integrations"><PageHeader title="Intégrations" /><AdminGoogleCalendar /><p className="text-sm text-fumee">Stripe : Finances & tarifs → Transactions Stripe · Telegram : Communication → Notifications Telegram.</p></div>
);

export const Journal = () => {
  const [data] = useAdminGet("/admin/hub/journal");
  if (!data) return <Loading />;
  return (
    <div className="space-y-6" data-testid="admin-journal">
      <PageHeader title="Journal technique" actions={<span className="text-sm text-fumee">Tentatives de connexion enregistrées : {data.tentatives_connexion}</span>} />
      <div><p className="eyebrow mb-2">Suppressions de réservations (archivées)</p><Table testid="admin-journal-deletions" cols={["Date", "Par", "Réservation", "Client", "Activité"]} empty="Aucune suppression." rows={data.suppressions.map((s) => [dt(s.supprime_le), s.supprime_par, <span className="font-mono text-xs">{s.booking?.reference}</span>, s.booking?.nom, s.booking?.event_titre])} /></div>
      <div><p className="eyebrow mb-2">Envois de la lettre</p><Table testid="admin-journal-newsletters" cols={["Date", "Sujet", "Envoyés"]} empty="Aucun envoi." rows={data.newsletters.map((e) => [dt(e.envoye_le), e.sujet, `${e.envoyes}/${e.destinataires}`])} /></div>
    </div>
  );
};

export const Seo = () => {
  const [urls, setUrls] = useState(null);
  const [q, setQ] = useState("");
  const sitemap = `${process.env.REACT_APP_BACKEND_URL}/api/sitemap.xml`;
  useEffect(() => { axios.get(sitemap).then((r) => setUrls([...String(r.data).matchAll(/<loc>([^<]+)<\/loc>/g)].map((m) => m[1]))).catch(() => setUrls([])); }, [sitemap]);
  if (!urls) return <Loading />;
  const shown = urls.filter((u) => u.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="admin-seo">
      <PageHeader title="Référencement" actions={<><span className="text-sm text-fumee" data-testid="admin-seo-count">{urls.length} pages indexables</span><a href={sitemap} target="_blank" rel="noreferrer" className={btn} data-testid="admin-seo-sitemap">Sitemap <ExternalLink className="w-3 h-3" /></a><a href="https://search.google.com/search-console" target="_blank" rel="noreferrer" className={btn}>Search Console <ExternalLink className="w-3 h-3" /></a></>} />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrer les URL" className={`${inputCls} sm:w-72 mb-3`} data-testid="admin-seo-filter" />
      <Table testid="admin-seo-table" cols={["URL publiée dans le sitemap"]} empty="Aucune URL." rows={shown.map((u) => [<a href={u} target="_blank" rel="noreferrer" className="text-xs text-terra break-all">{u}</a>])} />
    </div>
  );
};
